import { DateTime } from "luxon";

export const buildCalendar = (selectedDay: DateTime) => {
  let startDay = selectedDay.startOf("month").startOf("week");

  const endDay = selectedDay.endOf("month").endOf("week");

  const days = [];
  while (startDay < endDay) {
    days.push(startDay);
    startDay = startDay.plus({ days: 1 });
  }

  return { days, startDay: days[0], endDay: days[days.length - 1] };
};
